<script>
// Card de plano anual do Experts (benefícios: uma linha da descrição por item)
export default {
  props: {
    plan: {
      type: Object,
      default: () => ({})
    },
    recommended: {
      type: Boolean,
      default: false
    },
    // Texto do botão; vazio esconde o botão (ex.: tela de confirmação)
    action: {
      type: String,
      default: ""
    },
  },
  computed: {
    benefits() {
      if (!this.plan.description) {
        return [];
      }
      return this.plan.description
        .split(/\r?\n/)
        .map(row => row.trim())
        .filter(row => row.length > 0);
    },
  },
};
</script>

<template>
  <article class="plan-card" :class="{ 'is-recommended': recommended }" :aria-labelledby="'plan-' + plan.id">
    <span class="plan-card-bar" aria-hidden="true"></span>
    <div class="plan-card-head">
      <h3 :id="'plan-' + plan.id" class="plan-card-name">{{ plan.name }}</h3>
      <span v-if="recommended" class="plan-card-badge">MAIS ESCOLHIDO</span>
    </div>
    <p class="plan-card-price">{{ plan.value | currency }} <small>/ano</small></p>
    <p class="plan-card-month">equivale a {{ plan.value / 12 | currency }} por mês</p>
    <ul v-if="benefits.length > 0" class="plan-card-benefits">
      <li v-for="(benefit, index) in benefits" :key="index">
        <i class="bx bx-check" aria-hidden="true"></i>
        <span>{{ benefit }}</span>
      </li>
    </ul>
    <div v-if="action" class="plan-card-action">
      <button class="btn btn-lg btn-block text-uppercase" :class="recommended ? 'btn-default' : 'btn-outline-default'" v-on:click="$emit('choose', plan)">
        {{ action }}
      </button>
    </div>
  </article>
</template>
